import { Button } from './Button'
import '../App.css'
import React from 'react'
import './HeroSection.css'
import video1 from './video-1.mp4'
import { Link } from 'react-router-dom'

function HeroSection() {
  return (
    <div className='hero-container'>
        <video src={video1} autoPlay loop muted />
        <h1>IEEE Student Chapter</h1>
        <p>SRM INSTITUTE OF SCIENCE AND TECHNOLOGY, VADAPALANI</p>
        <div className='hero-btns'>
            <Button className='btns'
            buttonStyle='btn--outline'
            buttonSize='btn--large'
             ><Link to='/about' style={{color:"#fff",textDecoration:"none"}}> 
             About Us
            </Link>
            </Button>
            
            <Button className='btns'
            buttonStyle='btn--primary'
            buttonSize='btn--large'
            > 
            <Link to='/ContactUs' style={{textDecoration:"none"}}>
            Contact Us
            </Link>
            </Button>
            
        </div>
    </div>
  )
}

export default HeroSection